// extracted by mini-css-extract-plugin
export default {"meals":"MealsAvailable_meals__48t6k","meals-appear":"MealsAvailable_meals-appear__XHMg5","mealsload":"MealsAvailable_mealsload__1I1P4","mealError":"MealsAvailable_mealError__EY3GE"};